<template>
  <aside>
    <div class="bg-logo">
      <svg width="206" height="276" viewBox="0 0 206 276" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M128.918 0.0970706L186.708 24.6218V158.586L128.918 188.731V0.0970706ZM106.148 209.273V276L4.12 224.907L0 156.035L106.148 209.273ZM105.506 122.104V189.648L4.129 135.899V70.5009L105.506 122.104ZM229 223.88L128.273 274.972V208.756L229 156.846V223.88ZM104.846 102.287L40.658 71.6318L43.694 26.0572L104.846 0V102.287Z"
          fill="white" />
      </svg>
    </div>
    <div class="top-menu">
      <nav>
        <ul>
          <li>
            <router-link :to="{ name: 'company-info-service-cn' }" class="nav-link"
              :class="current == 'company-info-service-cn' ? 'active' : ''">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="lucide lucide-building-2">
                <path d="M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z" />
                <path d="M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2" />
                <path d="M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2" />
                <path d="M10 6h4" />
                <path d="M10 10h4" />
                <path d="M10 14h4" />
                <path d="M10 18h4" />
              </svg>
              <span>{{ $t("message.menu.company_information") }}</span>
            </router-link>
          </li>
          <li>
            <router-link :to="{ name: 'comply-advantage-index' }" class="nav-link"
              :class="current == 'comply-advantage-index' ? 'active' : ''">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M18.5858 5L13.3263 10.2595L9.48566 8.12584C9.07032 7.8951 8.54997 7.98846 8.24076 8.34921L2.24076 15.3492C1.88134 15.7685 1.9299 16.3998 2.34923 16.7593C2.76855 17.1187 3.39985 17.0701 3.75927 16.6508L9.228 10.2706L13.0144 12.3742C13.4047 12.591 13.8914 12.5228 14.2071 12.2071L20 6.41421V8C20 8.55228 20.4477 9 21 9C21.5523 9 22 8.55228 22 8V4C22 3.86441 21.973 3.73512 21.9241 3.61722C21.8753 3.49927 21.803 3.38877 21.7071 3.29289C21.6112 3.19702 21.5007 3.12468 21.3828 3.07588C21.2649 3.02699 21.1356 3 21 3H20.9998H17C16.4477 3 16 3.44772 16 4C16 4.55228 16.4477 5 17 5H18.5858ZM18 17C18 17.5523 18.4477 18 19 18C19.5523 18 20 17.5523 20 17V13C20 12.4477 19.5523 12 19 12C18.4477 12 18 12.4477 18 13V17ZM10 18C9.44773 18 9.00002 17.5523 9.00002 17V15C9.00002 14.4477 9.44773 14 10 14C10.5523 14 11 14.4477 11 15V17C11 17.5523 10.5523 18 10 18ZM2.00002 21C2.00002 20.4477 2.44773 20 3.00002 20H21C21.5523 20 22 20.4477 22 21C22 21.5523 21.5523 22 21 22H3.00002C2.44773 22 2.00002 21.5523 2.00002 21Z"
                  fill="white" />
              </svg>
              <span>{{ $t("message.menu.monitoring") }}</span>
            </router-link>
          </li>
          <li>
            <router-link :to="{ name: 'find-partner-410' }" class="nav-link"
              :class="current == 'find-partner-410' ? 'active' : ''">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                <path fill="white"
                  d="M14.33,12.9l5.38,5.38c.19,.19,.3,.45,.3,.71,0,.27-.11,.52-.3,.71-.19,.19-.45,.3-.71,.3-.27,0-.52-.11-.71-.3l-5.38-5.38c-1.61,1.25-3.63,1.83-5.66,1.64-2.03-.19-3.9-1.15-5.25-2.68C.65,11.76-.06,9.78,0,7.75,.07,5.71,.9,3.78,2.34,2.34,3.78,.9,5.71,.07,7.75,0c2.03-.06,4.01,.65,5.54,1.99,1.53,1.34,2.48,3.22,2.68,5.25,.19,2.03-.39,4.05-1.64,5.66h0Zm-6.33,1.1c1.59,0,3.12-.63,4.24-1.76s1.76-2.65,1.76-4.24-.63-3.12-1.76-4.24c-1.13-1.13-2.65-1.76-4.24-1.76s-3.12,.63-4.24,1.76-1.76,2.65-1.76,4.24,.63,3.12,1.76,4.24c1.13,1.13,2.65,1.76,4.24,1.76Z" />
                <path fill="white" d="M17.63,9.3h2.3v-2.39h1.4v2.39h2.32v1.32h-2.32v2.41h-1.4v-2.41h-2.3v-1.32Z" />
              </svg>
              <span>{{ $t("message.menu.find_partner_410") }}</span>
            </router-link>
          </li>
          <li>
            <router-link :to="{ name: 'find-partner-info' }" class="nav-link"
              :class="current == 'find-partner-info' ? 'active' : ''">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M16.3248 14.8992L21.7048 20.2792C21.8939 20.4685 22 20.7251 22 20.9926C21.9999 21.2601 21.8935 21.5166 21.7043 21.7057C21.515 21.8948 21.2584 22.001 20.9909 22.0009C20.7234 22.0008 20.4669 21.8945 20.2778 21.7052L14.8978 16.3252C13.2895 17.5709 11.267 18.1571 9.24189 17.9646C7.21674 17.7721 5.341 16.8153 3.99625 15.2888C2.6515 13.7624 1.93876 11.781 2.00302 9.74778C2.06728 7.71451 2.90372 5.78209 4.34217 4.34364C5.78063 2.90518 7.71305 2.06875 9.74631 2.00448C11.7796 1.94022 13.761 2.65296 15.2874 3.99771C16.8138 5.34246 17.7706 7.21821 17.9631 9.24336C18.1556 11.2685 17.5694 13.2909 16.3238 14.8992H16.3248ZM9.99977 16.0002C11.5911 16.0002 13.1172 15.3681 14.2424 14.2429C15.3676 13.1177 15.9998 11.5915 15.9998 10.0002C15.9998 8.40893 15.3676 6.88281 14.2424 5.75759C13.1172 4.63237 11.5911 4.00023 9.99977 4.00023C8.40847 4.00023 6.88235 4.63237 5.75713 5.75759C4.63191 6.88281 3.99977 8.40893 3.99977 10.0002C3.99977 11.5915 4.63191 13.1177 5.75713 14.2429C6.88235 15.3681 8.40847 16.0002 9.99977 16.0002Z"
                  fill="white" />
              </svg>
              <span>{{ $t("message.menu.find_partner") }}</span>
            </router-link>
          </li>
          <li v-if="this.$store.state.user.firstName == 'admin@alsy.by'">
            <router-link :to="{ name: 'annual-report-service-cn' }" class="nav-link"
              :class="current == 'annual-report-service-cn' ? 'active' : ''">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M16.3248 14.8992L21.7048 20.2792C21.8939 20.4685 22 20.7251 22 20.9926C21.9999 21.2601 21.8935 21.5166 21.7043 21.7057C21.515 21.8948 21.2584 22.001 20.9909 22.0009C20.7234 22.0008 20.4669 21.8945 20.2778 21.7052L14.8978 16.3252C13.2895 17.5709 11.267 18.1571 9.24189 17.9646C7.21674 17.7721 5.341 16.8153 3.99625 15.2888C2.6515 13.7624 1.93876 11.781 2.00302 9.74778C2.06728 7.71451 2.90372 5.78209 4.34217 4.34364C5.78063 2.90518 7.71305 2.06875 9.74631 2.00448C11.7796 1.94022 13.761 2.65296 15.2874 3.99771C16.8138 5.34246 17.7706 7.21821 17.9631 9.24336C18.1556 11.2685 17.5694 13.2909 16.3238 14.8992H16.3248ZM9.99977 16.0002C11.5911 16.0002 13.1172 15.3681 14.2424 14.2429C15.3676 13.1177 15.9998 11.5915 15.9998 10.0002C15.9998 8.40893 15.3676 6.88281 14.2424 5.75759C13.1172 4.63237 11.5911 4.00023 9.99977 4.00023C8.40847 4.00023 6.88235 4.63237 5.75713 5.75759C4.63191 6.88281 3.99977 8.40893 3.99977 10.0002C3.99977 11.5915 4.63191 13.1177 5.75713 14.2429C6.88235 15.3681 8.40847 16.0002 9.99977 16.0002Z"
                  fill="white" />
              </svg>
              <span>{{$t('message.contragent_search.annual_report')}}</span>
            </router-link>
          </li>
          <li v-if="this.$store.state.user.firstName == 'admin@alsy.by'">
            <router-link :to="{ name: 'enterprise-basic-information' }" class="nav-link"
              :class="current == 'enterprise-basic-information' ? 'active' : ''">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M16.3248 14.8992L21.7048 20.2792C21.8939 20.4685 22 20.7251 22 20.9926C21.9999 21.2601 21.8935 21.5166 21.7043 21.7057C21.515 21.8948 21.2584 22.001 20.9909 22.0009C20.7234 22.0008 20.4669 21.8945 20.2778 21.7052L14.8978 16.3252C13.2895 17.5709 11.267 18.1571 9.24189 17.9646C7.21674 17.7721 5.341 16.8153 3.99625 15.2888C2.6515 13.7624 1.93876 11.781 2.00302 9.74778C2.06728 7.71451 2.90372 5.78209 4.34217 4.34364C5.78063 2.90518 7.71305 2.06875 9.74631 2.00448C11.7796 1.94022 13.761 2.65296 15.2874 3.99771C16.8138 5.34246 17.7706 7.21821 17.9631 9.24336C18.1556 11.2685 17.5694 13.2909 16.3238 14.8992H16.3248ZM9.99977 16.0002C11.5911 16.0002 13.1172 15.3681 14.2424 14.2429C15.3676 13.1177 15.9998 11.5915 15.9998 10.0002C15.9998 8.40893 15.3676 6.88281 14.2424 5.75759C13.1172 4.63237 11.5911 4.00023 9.99977 4.00023C8.40847 4.00023 6.88235 4.63237 5.75713 5.75759C4.63191 6.88281 3.99977 8.40893 3.99977 10.0002C3.99977 11.5915 4.63191 13.1177 5.75713 14.2429C6.88235 15.3681 8.40847 16.0002 9.99977 16.0002Z"
                  fill="white" />
              </svg>
              <span>{{$t('message.contragent_search.enterprise_basic_information')}}</span>
            </router-link>
          </li>
          <li v-if="this.$store.state.user.firstName == 'admin@alsy.by'">
            <router-link :to="{ name: 'enterprise-risk-scan' }" class="nav-link"
              :class="current == 'enterprise-risk-scan' ? 'active' : ''">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M16.3248 14.8992L21.7048 20.2792C21.8939 20.4685 22 20.7251 22 20.9926C21.9999 21.2601 21.8935 21.5166 21.7043 21.7057C21.515 21.8948 21.2584 22.001 20.9909 22.0009C20.7234 22.0008 20.4669 21.8945 20.2778 21.7052L14.8978 16.3252C13.2895 17.5709 11.267 18.1571 9.24189 17.9646C7.21674 17.7721 5.341 16.8153 3.99625 15.2888C2.6515 13.7624 1.93876 11.781 2.00302 9.74778C2.06728 7.71451 2.90372 5.78209 4.34217 4.34364C5.78063 2.90518 7.71305 2.06875 9.74631 2.00448C11.7796 1.94022 13.761 2.65296 15.2874 3.99771C16.8138 5.34246 17.7706 7.21821 17.9631 9.24336C18.1556 11.2685 17.5694 13.2909 16.3238 14.8992H16.3248ZM9.99977 16.0002C11.5911 16.0002 13.1172 15.3681 14.2424 14.2429C15.3676 13.1177 15.9998 11.5915 15.9998 10.0002C15.9998 8.40893 15.3676 6.88281 14.2424 5.75759C13.1172 4.63237 11.5911 4.00023 9.99977 4.00023C8.40847 4.00023 6.88235 4.63237 5.75713 5.75759C4.63191 6.88281 3.99977 8.40893 3.99977 10.0002C3.99977 11.5915 4.63191 13.1177 5.75713 14.2429C6.88235 15.3681 8.40847 16.0002 9.99977 16.0002Z"
                  fill="white" />
              </svg>
              <span>{{$t('message.contragent_search.enterprise_risk_scan')}}</span>
            </router-link>
          </li>
          <li>
            <router-link :to="{ name: 'person-search-service' }" class="nav-link"
              :class="current == 'person-search-service' ? 'active' : ''">
              <svg width="24" height="24" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" stroke-width="3"
                fill="none">
                <circle cx="32" cy="18.14" r="11.14" fill-rule="evenodd" clip-rule="evenodd" fill="white" />
                <path fill-rule="evenodd" clip-rule="evenodd" fill="white"
                  d="M54.55,56.85A22.55,22.55,0,0,0,32,34.3h0A22.55,22.55,0,0,0,9.45,56.85Z" />
              </svg>
              <span>{{ $t("message.menu.find_person") }}</span>
            </router-link>
          </li>
          <li>
            <router-link :to="{ name: 'risk-control-service' }" class="nav-link"
              :class="current == 'risk-control-service' ? 'active' : ''">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path class="stroke" d="M12 7V13" stroke="white" stroke-width="2" stroke-linecap="round" />
                <circle cx="12" cy="16" r="1.5" fill="white" />
                <path class="stroke"
                  d="M7 3.33782C8.47087 2.48697 10.1786 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 10.1786 2.48697 8.47087 3.33782 7"
                  stroke="white" stroke-width="2" stroke-linecap="round" />
              </svg>
              <span>{{ $t("message.menu.risk_control") }}</span>
            </router-link>
          </li>
          <li>
            <router-link :to="{ name: 'business-note' }" class="nav-link"
              :class="current == 'business-note' ? 'active' : ''">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M10 2C9.44772 2 9 2.44772 9 3V5H3C2.44772 5 2 5.44772 2 6V17C2 19.7614 4.23858 22 7 22H17C19.7614 22 22 19.7614 22 17V3C22 2.44772 21.5523 2 21 2H10ZM4 7H9V16C9 16.5523 8.55228 17 8 17H7C6.44772 17 6 17.4477 6 18C6 18.5523 6.44772 19 7 19H8C9.65685 19 11 17.6569 11 16V6V4H20V17C20 18.6569 18.6569 20 17 20H7C5.34315 20 4 18.6569 4 17V7ZM13 6C12.4477 6 12 6.44772 12 7C12 7.55228 12.4477 8 13 8H18C18.5523 8 19 7.55228 19 7C19 6.44772 18.5523 6 18 6H13ZM12 11C12 10.4477 12.4477 10 13 10H18C18.5523 10 19 10.4477 19 11C19 11.5523 18.5523 12 18 12H13C12.4477 12 12 11.5523 12 11ZM13 14C12.4477 14 12 14.4477 12 15C12 15.5523 12.4477 16 13 16H18C18.5523 16 19 15.5523 19 15C19 14.4477 18.5523 14 18 14H13Z"
                  fill="white" />
              </svg>
              <span>{{ $t("message.menu.business_note") }}</span>
            </router-link>
          </li>
          <li>
            <router-link :to="{ name: 'short-search' }" class="nav-link"
              :class="current == 'short-search' ? 'active' : ''">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M10 2C9.44772 2 9 2.44772 9 3V5H3C2.44772 5 2 5.44772 2 6V17C2 19.7614 4.23858 22 7 22H17C19.7614 22 22 19.7614 22 17V3C22 2.44772 21.5523 2 21 2H10ZM4 7H9V16C9 16.5523 8.55228 17 8 17H7C6.44772 17 6 17.4477 6 18C6 18.5523 6.44772 19 7 19H8C9.65685 19 11 17.6569 11 16V6V4H20V17C20 18.6569 18.6569 20 17 20H7C5.34315 20 4 18.6569 4 17V7ZM13 6C12.4477 6 12 6.44772 12 7C12 7.55228 12.4477 8 13 8H18C18.5523 8 19 7.55228 19 7C19 6.44772 18.5523 6 18 6H13ZM12 11C12 10.4477 12.4477 10 13 10H18C18.5523 10 19 10.4477 19 11C19 11.5523 18.5523 12 18 12H13C12.4477 12 12 11.5523 12 11ZM13 14C12.4477 14 12 14.4477 12 15C12 15.5523 12.4477 16 13 16H18C18.5523 16 19 15.5523 19 15C19 14.4477 18.5523 14 18 14H13Z"
                  fill="white" />
              </svg>
              <span>{{ $t("message.menu.short_search") }}</span>
            </router-link>
          </li>
          <li v-if="this.$store.state.user.firstName == 'admin@alsy.by' || this.$store.state.user.firstName == '502507079@qq.com'">
            <router-link :to="{ name: 'case-filling-info-service' }" class="nav-link"
              :class="current == 'case-filling-info-service' ? 'active' : ''">
              <svg width="24" height="24" viewBox="0 -2 24 26" fill="none" xmlns="http://www.w3.org/2000/svg" > <path d="M14 -1c1.105 0 2 .895 2 2v2h-1.5V1a.5.5 0 0 0-.5-.5h-4A.5.5 0 0 0 9.5 1v2H8V1c0-1.105.895-2 2-2h4z" fill="white"/> <path d="M11.293 11.293a1 1 0 0 1 1.414 1.414A1 1 0 0 1 11.293 11.293z" fill="white"/> <path d="M2.594 13.805a19.148 19.148 0 0 0 18.812 0c.415-.256.855.35.494.715a20.15 20.15 0 0 1-19.8 0c-.36-.365.08-.971.494-.715z" fill="white"/> <path d="M4 2h16a4 4 0 0 1 4 4v14a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V6a4 4 0 0 1 4-4zm0 2a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H4z" fill="white"/> </svg>
              <span>{{ $t("message.menu.case_filling_info") }}</span>
            </router-link>
          </li>
          <li v-if="this.$store.state.user.firstName == 'admin@alsy.by' || this.$store.state.user.firstName == '502507079@qq.com'">
            <router-link :to="{ name: 'business-score-service' }" class="nav-link"
              :class="current == 'business-score-service' ? 'active' : ''">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"> <path fill-rule="evenodd" clip-rule="evenodd" d="M10 2C9.44772 2 9 2.44772 9 3V5H3C2.44772 5 2 5.44772 2 6V17C2 19.7614 4.23858 22 7 22H17C19.7614 22 22 19.7614 22 17V3C22 2.44772 21.5523 2 21 2H10ZM4 7H9V16C9 16.5523 8.55228 17 8 17H7C6.44772 17 6 17.4477 6 18C6 18.5523 6.44772 19 7 19H8C9.65685 19 11 17.6569 11 16V6V4H20V17C20 18.6569 18.6569 20 17 20H7C5.34315 20 4 18.6569 4 17V7ZM13 6C12.4477 6 12 6.44772 12 7C12 7.55228 12.4477 8 13 8H18C18.5523 8 19 7.55228 19 7C19 6.44772 18.5523 6 18 6H13ZM12 11C12 10.4477 12.4477 10 13 10H18C18.5523 10 19 10.4477 19 11C19 11.5523 18.5523 12 18 12H13C12.4477 12 12 11.5523 12 11ZM13 14C12.4477 14 12 14.4477 12 15C12 15.5523 12.4477 16 13 16H18C18.5523 16 19 15.5523 19 15C19 14.4477 18.5523 14 18 14H13Z" fill="white" /> </svg>
              <span>{{ $t("message.menu.business_score") }}</span>
            </router-link>
          </li>
          <li>
            <router-link :to="{ name: 'topup-account' }" class="nav-link"
              :class="current == 'topup-account' ? 'active' : ''">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M16.1225 2.06823C16.6249 1.87285 17.1918 2.11085 17.4041 2.60631L18.8586 6.00023H19C20.6569 6.00023 22 7.34338 22 9.00023V10.0002V12.0002V15.0002V17.0002V19.0002C22 20.6571 20.6569 22.0002 19 22.0002H5C3.34315 22.0002 2 20.6571 2 19.0002V9.00023C2 7.34338 3.34315 6.00023 5 6.00023H6.01223L6.0316 5.99247L16.1225 2.06823ZM20 15.0002V12.0002H17C16.4477 12.0002 16 12.4479 16 13.0002V14.0002C16 14.5525 16.4477 15.0002 17 15.0002H20ZM20 10.0002V9.00023C20 8.44795 19.5523 8.00023 19 8.00023H5C4.44772 8.00023 4 8.44795 4 9.00023V19.0002C4 19.5525 4.44772 20.0002 5 20.0002H19C19.5523 20.0002 20 19.5525 20 19.0002V17.0002H17C15.3431 17.0002 14 15.6571 14 14.0002V13.0002C14 11.3434 15.3431 10.0002 17 10.0002H20ZM15.9466 4.28257L16.6827 6.00023H11.5297L15.9466 4.28257Z"
                  fill="white" />
              </svg>
              <span>{{ $t("message.account.topup_account") }}</span>
            </router-link>
          </li>
          <li class="folded foldable main-foldable">
            <router-link :to="{ name: 'education-index' }" class="nav-link"
              :class="current.includes('education') ? 'active' : ''">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M21.8895 8.55181C21.8499 8.47748 21.803 8.40724 21.7495 8.34212C21.675 8.26804 21.5909 8.20424 21.4995 8.1524L11.7395 3.10985C11.5875 3.02221 11.415 2.97607 11.2395 2.97607C11.064 2.97607 10.8915 3.02221 10.7395 3.10985L2.4495 8.10247C2.30317 8.19833 2.1846 8.33086 2.10563 8.48681C2.02667 8.64275 1.99007 8.81667 1.9995 8.99116C2.0033 9.16469 2.05233 9.33424 2.14177 9.48307C2.2312 9.63191 2.35795 9.7549 2.5095 9.83991L4.4395 10.9882V15.871C4.43977 16.032 4.47901 16.1905 4.55388 16.3331C4.62875 16.4756 4.73703 16.598 4.8695 16.6898L10.9295 20.8436C11.1023 20.9426 11.3008 20.9879 11.4995 20.9735C11.6955 20.9719 11.8868 20.9129 12.0495 20.8037L18.2395 16.6798C18.3771 16.5893 18.4901 16.4664 18.5686 16.3218C18.6471 16.1772 18.6886 16.0155 18.6895 15.851V11.2478L19.9995 10.6088V15.841C19.9995 16.1059 20.1049 16.3598 20.2924 16.5471C20.4799 16.7344 20.7343 16.8396 20.9995 16.8396C21.2647 16.8396 21.5191 16.7344 21.7066 16.5471C21.8941 16.3598 21.9995 16.1059 21.9995 15.841V8.99116C21.9997 8.83789 21.9619 8.68695 21.8895 8.55181ZM16.6895 15.3418L11.5095 18.7867L6.4395 15.3118V12.0766L10.8895 14.5629C11.0329 14.6381 11.1925 14.6774 11.3545 14.6774C11.5165 14.6774 11.6761 14.6381 11.8195 14.5629L16.6895 12.1964V15.3418ZM11.4095 12.5659L4.9995 8.99116L11.3195 5.14684L18.7695 8.99116L11.4095 12.5659Z"
                  fill="white" />
              </svg>
              <span>{{ $t("message.menu.education") }}</span>
            </router-link>
            <button class="btn btn-unfold" @click="($event) => {
              $event.target.closest('li').classList.toggle('folded');
            }
              ">
              <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 512 512">
                <path
                  d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z" />
              </svg>
            </button>
            <ul>
              <li class="folded foldable">
                <router-link :to="{ name: 'education-videos' }" class="nav-link">{{ $t("message.education.videos")
                  }}</router-link>
                <button class="btn btn-unfold" @click="($event) => {
                  $event.target.closest('li').classList.toggle('folded');
                }
                  ">
                  <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 512 512">
                    <path
                      d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z" />
                  </svg>
                </button>
                <ul>
                  <li>
                    <router-link :to="{
                      name: 'education-videos-single',
                      params: { hash: 'ca' },
                    }" class="nav-link">
                      Мониторинг и проверки
                    </router-link>
                  </li>
                  <li>
                    <router-link :to="{
                      name: 'education-videos-single',
                      params: { hash: '410' },
                    }" class="nav-link">Поиск контрагентов в Китае с рейтингами</router-link>
                  </li>
                  <li>
                    <router-link :to="{
                      name: 'education-videos-single',
                      params: { hash: '886' },
                    }" class="nav-link">Простой поиск контрагентов в китае</router-link>
                  </li>
                  <li>
                    <router-link :to="{
                      name: 'education-videos-single',
                      params: { hash: 'note' },
                    }" class="nav-link">Бизнес справка по Китайской компании</router-link>
                  </li>
                </ul>
              </li>
              <li class="folded foldable">
                <router-link :to="{ name: 'education-examples' }" class="nav-link">{{ $t("message.education.examples")
                  }}</router-link>
                <button class="btn btn-unfold" @click="($event) => {
                  $event.target.closest('li').classList.toggle('folded');
                }
                  ">
                  <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 512 512">
                    <path
                      d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z" />
                  </svg>
                </button>
                <ul>
                  <li>
                    <router-link :to="{
                      name: 'education-examples-single',
                      params: { hash: 'ca' },
                    }" class="nav-link">Мониторинг и проверки</router-link>
                  </li>
                  <li>
                    <router-link :to="{
                      name: 'education-examples-single',
                      params: { hash: '410' },
                    }" class="nav-link">Поиск контрагентов в Китае с рейтингами</router-link>
                  </li>
                  <li>
                    <router-link :to="{
                      name: 'education-examples-single',
                      params: { hash: '886' },
                    }" class="nav-link">Простой поиск контрагентов в Китае</router-link>
                  </li>
                  <li>
                    <router-link :to="{
                      name: 'education-examples-single',
                      params: { hash: 'note' },
                    }" class="nav-link">Бизнес справка по Китайской компании</router-link>
                  </li>
                </ul>
              </li>
              <li>
                <router-link :to="{ name: 'education-manuals' }" class="nav-link">{{ $t("message.education.manuals")
                  }}</router-link>
              </li>

              <!-- список конкретных документов -->

              <li>
                <router-link :to="{ name: 'education-links' }" class="nav-link">{{ $t("message.education.links")
                  }}</router-link>
              </li>

              <!-- ссылки на ресурсы, пока на главную АТБ -->
            </ul>
          </li>

          <li name="contracts-nav-link" class="nav-item">
            <!-- v-if="is_contracts"-->
            <router-link :to="{ name: 'contracts-index' }" class="nav-link"
              :class="current == 'contracts-index' ? 'active' : ''">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M7 4H17C17.5523 4 18 4.44772 18 5V19C18 19.5523 17.5523 20 17 20H7C6.44772 20 6 19.5523 6 19V5C6 4.44772 6.44771 4 7 4ZM4 5C4 3.34315 5.34315 2 7 2H17C18.6569 2 20 3.34315 20 5V19C20 20.6569 18.6569 22 17 22H7C5.34315 22 4 20.6569 4 19V5ZM9 6C8.44772 6 8 6.44772 8 7C8 7.55228 8.44772 8 9 8H15C15.5523 8 16 7.55228 16 7C16 6.44772 15.5523 6 15 6H9ZM8 11C8 10.4477 8.44772 10 9 10H15C15.5523 10 16 10.4477 16 11C16 11.5523 15.5523 12 15 12H9C8.44772 12 8 11.5523 8 11ZM9 14C8.44772 14 8 14.4477 8 15C8 15.5523 8.44772 16 9 16H11.5C12.0523 16 12.5 15.5523 12.5 15C12.5 14.4477 12.0523 14 11.5 14H9Z"
                  fill="#fff" />
              </svg>
              <span>{{ $t("message.menu.orders") }}</span>
            </router-link>
          </li>
          <li class="nav-item">
            <!-- v-if="is_contracts"-->
            <router-link :to="{ name: 'deals-index' }" class="nav-link"
              :class="current == 'deals-index' ? 'active' : ''">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M19 4H5C4.44771 4 4 4.44772 4 5V20H6.17157L6.29289 19.8787C6.8555 19.3161 7.61856 19 8.41421 19H14.6972C15.2895 19 15.8685 19.1753 16.3613 19.5038L17.1056 20H20V5C20 4.44771 19.5523 4 19 4ZM5 2C3.34315 2 2 3.34315 2 5V21C2 21.5523 2.44772 22 3 22H6.58579C6.851 22 7.10536 21.8946 7.29289 21.7071L7.70711 21.2929C7.89464 21.1054 8.149 21 8.41421 21H14.6972C14.8946 21 15.0877 21.0584 15.2519 21.1679L16.2481 21.8321C16.4123 21.9416 16.6054 22 16.8028 22H21C21.5523 22 22 21.5523 22 21V5C22 3.34315 20.6569 2 19 2H5Z"
                  fill="#fff" />
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M14.5 13C15.3284 13 16 12.3284 16 11.5C16 10.6716 15.3284 10 14.5 10C13.6716 10 13 10.6716 13 11.5C13 12.3284 13.6716 13 14.5 13ZM14.5 15C16.433 15 18 13.433 18 11.5C18 9.567 16.433 8 14.5 8C12.567 8 11 9.567 11 11.5C11 13.433 12.567 15 14.5 15Z"
                  fill="#fff" />
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M7 8C7.55228 8 8 8.44772 8 9V14C8 14.5523 7.55228 15 7 15C6.44772 15 6 14.5523 6 14V9C6 8.44772 6.44772 8 7 8Z"
                  fill="#fff" />
              </svg>
              <span>
                {{ $t("message.menu.deals") }}
              </span>
            </router-link>
          </li>
        </ul>
      </nav>
    </div>
    <div class="bottom-menu">
      <nav>
        <ul>
          <li>
            <a v-b-modal:modal-contact style="cursor: pointer" class="nav-link">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M8.34459 15.7675C8.68241 15.5284 9.08607 15.4 9.49993 15.4H18.9999V5H5.00883L5.00195 18.133L8.34459 15.7675ZM3.00893 4.8L3.00195 18.132C3.0011 19.7552 4.8323 20.7032 6.15729 19.7656L9.49993 17.4H19.1999C20.1899 17.4 20.9999 16.59 20.9999 15.6V4.8C20.9999 3.81 20.1899 3 19.1999 3H4.79993C3.80993 3 3.00893 3.81 3.00893 4.8ZM6 8C6 7.44772 6.44772 7 7 7H17C17.5523 7 18 7.44772 18 8C18 8.55228 17.5523 9 17 9H7C6.44772 9 6 8.55228 6 8ZM7 11C6.44772 11 6 11.4477 6 12C6 12.5523 6.44772 13 7 13H12C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11H7Z"
                  fill="white" />
              </svg>
              <span>{{ $t("message.menu.ask_a_question") }}</span>
            </a>
          </li>
          <li>
            <span @click="logoutInit" class="nav-link">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M15 2C14.4477 2 14 2.44772 14 3C14 3.55228 14.4477 4 15 4H19C19.2652 4 19.5196 4.10536 19.7071 4.29289C19.8947 4.48043 20 4.73478 20 5V19C20 19.2652 19.8947 19.5196 19.7071 19.7071C19.5196 19.8946 19.2652 20 19 20H15C14.4477 20 14 20.4477 14 21C14 21.5523 14.4477 22 15 22H19C19.7957 22 20.5587 21.6839 21.1213 21.1213C21.6839 20.5587 22 19.7957 22 19V5C22 4.20435 21.6839 3.44129 21.1213 2.87868C20.5587 2.31607 19.7957 2 19 2H15ZM8.70711 17.7071C8.31658 18.0976 7.68342 18.0976 7.29289 17.7071L2.29366 12.7079L2.28639 12.7006C2.19374 12.6062 2.12357 12.498 2.07588 12.3828C2.02776 12.2668 2.00086 12.1397 2.00002 12.0065L2 12L2.00004 11.9908C2.00236 11.7379 2.09998 11.4858 2.29289 11.2929L7.29289 6.29289C7.68342 5.90237 8.31658 5.90237 8.70711 6.29289C9.09763 6.68342 9.09763 7.31658 8.70711 7.70711L5.41421 11L15 11C15.5523 11 16 11.4477 16 12C16 12.5523 15.5523 13 15 13L5.41421 13L8.70711 16.2929C9.09763 16.6834 9.09763 17.3166 8.70711 17.7071Z"
                  fill="white" />
              </svg>
              <span>{{ $t("message.menu.logout") }}</span>
            </span>
          </li>
        </ul>
      </nav>
    </div>
    <b-modal id="modal-contact" size="md" :title="$t('message.atb_home.contact_form_title')" :hide-footer="true">
      <contactForm :nopadding="true" />
    </b-modal>
  </aside>
</template>

<script>
import contactForm from "./contact-form.vue";
export default {
  name: "asider",
  components: { contactForm },
  methods: {
    logoutInit() {
      this.$root.$emit("logout");
    },
    fetchIfIsContractsMenu() {
      let status = localStorage.getItem("attis-contracts");
      if (status == null) status = "0";
      this.is_contracts = parseInt(status);
    },
  },
  mounted() {
    this.$root.$on("contractMenuChanged", () => {
      this.fetchIfIsContractsMenu();
    });
    this.fetchIfIsContractsMenu();
  },
  data() {
    return {
      is_contracts: false,
    };
  },
  computed: {
    current() {
      return this.$route.name;
    },
  },
};
</script>

<style scoped>
aside {
  /* attis/secondary */
  width: 100%;
  min-height: calc(100vh - 112px);
  background: var(--color2);
  box-shadow: 0px 30px 40px rgba(71, 178, 228, 0.5),
    0px 40px 60px rgba(71, 178, 228, 0.1);
  border-radius: 20px;
  position: relative;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
}

.bg-logo {
  position: absolute;
  bottom: 70px;
  right: -40px;
  opacity: 0.06;
  z-index: 1;
}

aside nav ul {
  list-style: none;
  padding: 0;
  margin: 0;
  padding: 20px;
}

aside nav ul li a,
aside nav ul li>span {
  display: flex;
  align-items: center;
  padding: 12px;
  gap: 26px;
  width: 100%;
}

aside nav ul a,
aside nav ul span {
  color: #fff;
}

aside .bottom-menu {
  margin-top: auto;
}

aside nav ul li a.nav-link.active {
  background: #ffffff;
  border-radius: 24px;
}

aside nav ul li a.nav-link.active svg,
aside nav ul li a.nav-link.active svg path {
  fill: #fe5000 !important;
}

aside nav ul li a.nav-link.active svg path.stroke {
  stroke: #fe5000 !important;
  fill: none !important;
}

aside nav ul li a.nav-link.active svg circle {
  fill: #fe5000 !important;
}

aside nav ul li a.nav-link.active span {
  color: var(--color1);
}

.nav-link,
.nav-link span {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.nav-link svg {
  min-width: 24px;
  max-width: 24px;
}

aside nav ul ul {
  padding: 0;
  padding-left: 60px;
}

aside nav ul>li>ul {
  margin-top: 10px;
}

aside nav ul ul .nav-link {
  padding: 3px;
  line-height: 16px;
  margin-bottom: 5px;
}

aside nav ul ul ul {
  padding-left: 1em;
}

aside nav ul ul ul li a.nav-link {
  font-size: 14px;
}

aside nav li.folded ul {
  display: none;
}

.foldable {
  position: relative;
}

.foldable .btn-unfold {
  position: absolute;
  right: 10px;
  top: 0;
  padding: 5px;
  color: #fff;
  z-index: 5;
}

.foldable .btn-unfold svg {
  fill: #fff;
  transform: scaleY(-1);
}

.foldable.folded .btn-unfold svg {
  transform: scaleY(1);
}

.main-foldable button {
  top: 10px !important;
  right: 10px;
}

.main-foldable .active+button svg {
  fill: #47b2e4;
}
</style>
